export const mockNotifications = [
    {
        subject: "Repair",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 28, 2024 03:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Repair Needed",
        message: "Mike Loreipsum started following Monica Smith.",
        date:  new Date('July 29, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Another Subject",
        message: "This is a really long notification message. I just wanted to test this to see if it was legit.",
        date: new Date(),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 11, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 22, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 13, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 2, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Repair",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 28, 2024 03:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Repair Needed",
        message: "Mike Loreipsum started following Monica Smith.",
        date:  new Date('July 29, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Another Subject",
        message: "This is a really long notification message. I just wanted to test this to see if it was legit.",
        date: new Date(),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 11, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 22, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 13, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 2, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Repair",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 28, 2024 03:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Repair Needed",
        message: "Mike Loreipsum started following Monica Smith.",
        date:  new Date('July 29, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Another Subject",
        message: "This is a really long notification message. I just wanted to test this to see if it was legit.",
        date: new Date(),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 11, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 22, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 13, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 2, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Repair",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 28, 2024 03:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Repair Needed",
        message: "Mike Loreipsum started following Monica Smith.",
        date:  new Date('July 29, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Another Subject",
        message: "This is a really long notification message. I just wanted to test this to see if it was legit.",
        date: new Date(),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 11, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 22, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 13, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: true,
    },
    {
        subject: "Awesome Sub",
        message: "Mike Loreipsum started following Monica Smith.",
        date: new Date('July 2, 2024 11:24:00'),
        equipment_id: '2Djx6sJ1DBwJqp8FhQ1p',
        read: false,
    },
];